<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Subscription Plan</div>
      <div>
        <label>Current Plan</label>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex-24">
          <div class="bmw-lg-subscription-oval" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            {{'$'+currentPlanPrice}}
          </div>
        </div>
        <div class="flex" style="line-height: 2">
          <div>
            {{currentPlanDescription}} 
          </div>
        </div>
      </div>
    
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">Subscription Plan</div>
      <div>
        <label>Current Plan</label>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex-24">
          <div class="bmw-lg-subscription-oval" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            {{'$'+currentPlanPrice}}
          </div>
        </div>
        <div class="flex" style="line-height: 2">
          <div>
            {{currentPlanDescription}} 
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
